import type { RouteObject } from 'react-router';
import { MaintenancePage } from './pages/MaintenancePage';

/** One screen: the service items, each with the truck classes it applies to. A truck's own plan and records are tabs on its Fleet page. */
export const MAINTENANCE_ROUTES: RouteObject[] = [{ path: 'maintenance', element: <MaintenancePage /> }];
